import React from "react";
import { Map, Marker, NavigationControl } from "react-map-gl";
import { SimplifiedVehicle } from "./Mapbox.model";
import imgScooter from "../assets/scooter.png";
import axios from "axios";
import "mapbox-gl/dist/mapbox-gl.css";
import mapboxgl from "mapbox-gl";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
mapboxgl.workerClass =
  // eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved, @typescript-eslint/no-var-requires
  require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

class Mapbox extends React.Component<
  Record<string, unknown>,
  { vehicles: SimplifiedVehicle[]; lng: number; lat: number; zoom: number }
> {
  private readonly vehiclesApiUrl = process.env.REACT_APP_VEHICLE_API;
  private readonly mapboxAccessToken = process.env.REACT_APP_MAPBOX_TOKEN;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(props: any) {
    super(props);
    this.state = {
      vehicles: [],
      lat: 50.084188,
      lng: 14.423595,
      zoom: 12,
    };
  }

  saveScootersToState = (resp: SimplifiedVehicle[]) => {
    this.setState({ vehicles: resp });
  };

  /**
   * window.location.search = lat=50.0722233&lng=14.4542564&mapsZoomDefaultLevelWeb=
   */
  private checkQueryParams() {
    if (window.location.search) {
      const params = new URLSearchParams(window.location.search);
      const lng = params.get("lng");
      const lat = params.get("lat");
      const mapsZoomDefaultLevelWeb = params.get("mapsZoomDefaultLevelWeb");
      this.setState({
        lng: Number(lng),
        lat: Number(lat),
        zoom: Number(mapsZoomDefaultLevelWeb),
      });
      console.log(lng, lat, mapsZoomDefaultLevelWeb);
    }
  }

  fetchScooterData = () => {
    axios
      .request({
        method: "get",
        url: this.vehiclesApiUrl,
      })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((resp: any) => {
        this.saveScootersToState(resp.data);
      })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .catch((err: any) => {
        console.error("something wrong happened", err);
      });
  };

  componentDidMount() {
    this.checkQueryParams();
    this.fetchScooterData();
  }

  render() {
    return (
      <Map
        initialViewState={{
          longitude: this.state.lng,
          latitude: this.state.lat,
          zoom: this.state.zoom,
        }}
        mapStyle="mapbox://styles/sadl/cka2j4d743lwp1ipcrduz815r"
        mapboxAccessToken={this.mapboxAccessToken}
        style={{ width: "100vw", height: "100vh" }}
      >
        <React.Fragment>
          {Array.isArray(this.state.vehicles) ? (
            this.state.vehicles.map(
              (vehicle: SimplifiedVehicle, idx: number) => {
                return (
                  <Marker
                    anchor="center"
                    key={idx}
                    latitude={vehicle.lat}
                    longitude={vehicle.lng}
                    style={{ pointerEvents: "none" }}
                  >
                    <img alt={"berider marker"} src={imgScooter} />
                  </Marker>
                );
              }
            )
          ) : (
            <Marker anchor="center" latitude={0} longitude={0}>
              <img alt={"berider marker"} src={imgScooter} />
            </Marker>
          )}
          <NavigationControl position="bottom-right" showZoom />
        </React.Fragment>
      </Map>
    );
  }
}

export default Mapbox;
